// When a coaching session can be marked as done (coaching-admin › saveSessionRecord; the session panel only
// reflects it). A session is "realizada" only once its start time has come: a scheduled session in the future, or
// one without a time, cannot be marked done. If it really happened earlier (moved by phone, held before the booked
// time), the coach writes the real start (`happenedAt`, never in the future): an explicit correction, logged in the
// session's history with the time it had before. Nothing is changed on its own, and no earlier record is rewritten.

const SKEW_MS = 60 * 1000; // a clock a minute ahead never blocks a session that is starting now

/** null when it can be marked done; otherwise the reason: 'session_not_started', 'session_start_required' or 'invalid_happened_at'. */
export function doneProblem({ startsAt = null, happenedAt = null, now = Date.now() } = {}) {
  if (happenedAt !== null && happenedAt !== undefined && happenedAt !== '') {
    const t = Date.parse(happenedAt);
    if (!Number.isFinite(t)) return 'invalid_happened_at';
    return t > now + SKEW_MS ? 'session_not_started' : null;
  }
  if (!startsAt) return 'session_start_required';
  const s = Date.parse(startsAt);
  if (!Number.isFinite(s)) return 'session_start_required';
  return s > now + SKEW_MS ? 'session_not_started' : null;
}
